import React, { useEffect, useState } from 'react';
import { func } from 'prop-types';
import { useRouter } from '../../utils/router';
import Button from '../atoms/Button';
import { useTranslate } from '../../translate/I18n';

const BackArrow = () => {
  const { t } = useTranslate(['common']);
  const history = useRouter();

  const goBack = () => history.query?.overrideGoBack ? history.push(history.query.overrideGoBack) : history.goBack();

  return (
    <Button
      styleType="transparent"
      color="greyDark"
      data-cy="mission-goBack"
      py={0}
      px={1}
      ml="-8px"
      onClick={() => goBack()}>
      <i className="icon icon-arrow-left"> </i>
      {t('common:back')}
    </Button>
  );
};

export default BackArrow;
